<script>
import {
  calcDeltaPrice
} from '@/utils/helpers'

import PopupPenalties from '@/components/views/penalties/PopupPenalties.vue'
import {
  rexRoundedSingleSelect,
  rexRoundedText,
  rexRoundedTime,
  rexRoundedAutocomplete,
  rexRoundedDate
} from '@/components/views/rexRoundedField'

export default {
  name: 'transfers-form',
  components: {
    PopupPenalties,
    rexRoundedSingleSelect,
    rexRoundedText,
    rexRoundedTime,
    rexRoundedAutocomplete,
    rexRoundedDate
  },
  props: {
    formIsShown: {
      type: Boolean,
      default: () => true
    },
    resultIsShown: {
      type: Boolean,
      default: () => false
    },
    transferIndex: {
      type: Number,
      required: true
    }
  },
  computed: {
    getTransfer() {
      return this.$store.getters['cart/getTransfer'](this.transferIndex)
    },
    mainServiceIsTours() {
      return this.$store.getters['cart/getMainService'] === 'tours'
    },
    getTransferForm() {
      return this.$store.getters['cart/getTransferForm'](this.transferIndex)
    },
    getDates() {
      return this.$store.getters['cart/getDates']
    },
    getLocations() {
      return this.$store.getters['cart/getLocations']
    },
    getTransfersCollection() {
      const currentTransfersPriceAmount = this.getTransfer.current.price.amount

      return this.getTransfer.collection.map(item => ({
        slug: item.slug,
        name: `${item.name} ${calcDeltaPrice(currentTransfersPriceAmount, item.price.amount)} ${item.price.currency}`
      }))
    },
    pickUpLocationData() {
      const slug = this.getTransferForm.placeFrom.current
      const [routeId, code] = slug ? slug.split('_') : ['', '']

      return {
        routeId,
        code
      }
    },
    isPlaceSelectorDisabled() {
      let disabled = true

      if (!this.resultIsShown) {
        disabled = !this.getTransferForm.placeFrom.collection.length
      }

      return disabled
    },
  },
  watch: {
    getDates: {
      // eslint-disable-next-line
      handler: function () {
        this.setTransfersDates(this.getDates)
      },
      deep: true
    }
  },
  created() {
    this.setTransfersDates(this.getDates)
    this.setTransfersResidence()
  },
  methods: {
    search() {
      this.$parent.formIsShown = false
      this.$parent.resultIsShown = true

      this.$store.commit('cart/updateServiceModuleIsLoading', {
        status: true,
        target: `transfers.${this.transferIndex}.transfers`,
      })

      this.$store.dispatch('cart/getTransfers', {
        transferIndex: this.transferIndex,
        form: {
          ...this.$store.getters['cart/getTransferFormForSearch'](this.transferIndex)
        }
      })
    },
    changedTransferPlace({ event: { slug } }, direction) {
      if (slug) {
        this.$store.dispatch('cart/getCityLocations', {
          placeId: slug,
          direction,
          transferIndex: this.transferIndex
        })
      } else {
        this.$store.commit('cart/setCitiesLocations', {
          collection: [],
          direction,
          transferIndex: this.transferIndex
        })

        this.$store.commit('cart/updateServiceField', {
          target: `transfers.${this.transferIndex}.form.${direction}.current`,
          value: null
        })
      }
    },
    setTransfersDates({ startDate, endDate }) {
      if (!this.mainServiceIsTours) {
        this.$store.commit('cart/updateServiceField', {
          target: `transfers.${this.transferIndex}.form.checkInDate`,
          value: startDate
        })

        this.$store.commit('cart/updateServiceField', {
          target: `transfers.${this.transferIndex}.form.checkOutDate`,
          value: endDate
        })
      }
    },
    setTransfersResidence() {
      const {
        placeTo,
        cityTo
      } = this.getLocations

      if (placeTo.slug) {
        this.$store.commit('cart/updateServiceField', {
          target: `transfers.${this.transferIndex}.form.cityTo`,
          value: cityTo
        })

        this.$store.commit('cart/updateServiceField', {
          target: `transfers.${this.transferIndex}.form.placeTo.collection`,
          value: [{
            label: '',
            collection: [{
              badge: null,
              code: placeTo.code,
              name: placeTo.name,
              slug: `${placeTo.slug}_H`
            }]
          }]
        })

        this.$store.commit('cart/updateServiceField', {
          target: `transfers.${this.transferIndex}.form.placeTo.current`,
          value: `${placeTo.slug}_${placeTo.code}`
        })
      }
    },
    select() {
      this.$store.dispatch('cart/getActualize')
      this.$store.commit('cart/removeServiceFromAllPenalties', {
        service: 'transfers',
        serviceId: this.getTransfer.searchId
      })

      const {
        searchId: transferSearchId,
        id: transferId,
        vehicleId
      } = this.$store.getters['cart/getIds'].transfers[this.transferIndex]

      if (transferId) {
        this.$store.dispatch('cart/getServicePenaltiesForAll', {
          ids: {
            transferSearchId,
            transferId,
            vehicleId,
            currency: this.$store.getters['cart/getCartPrice'].currency
          },
          serviceName: 'transfers',
          serviceId: this.getTransfer.searchId,
          apiModuleName: 'transfers',
          label: 'Трансфер'
        })
      }
    }
  }
}
</script>

<template>
  <div
    class="cart__transfers"
    :class="{ 'cart__transfers-tour': mainServiceIsTours }"
  >
    <div
      class="cart__search-form--row"
      :class="{ 'cart__search-form--row-tour': mainServiceIsTours }"
    >
      <rex-rounded-autocomplete
        label="Откуда"
        store-module="cart"
        getter-name="getServiceField"
        setter-name="updateServiceField"
        :target="`transfers.${transferIndex}.form.cityFrom`"
        :css-class="mainServiceIsTours ? 'cart__search-form--w47-75' : 'cart__search-form--w30'"
        endpoint="transfers"
        :disabled="resultIsShown"
        @onChange="changedTransferPlace($event, 'placeFrom')"
      />
      <rex-rounded-single-select
        label=""
        store-module="cart"
        getter-name="getServiceField"
        setter-name="updateServiceField"
        :target="`transfers.${transferIndex}.form.placeFrom.current`"
        :css-class="mainServiceIsTours
          ? 'cart__search-form--w47-75 cart__search-form--without-label'
          : 'cart__search-form--w30 cart__search-form--without-label'"
        :hide-if-empty="false"
        :is-grouped="true"
        :data="getTransferForm.placeFrom.collection"
        :disabled="isPlaceSelectorDisabled"
      />
      <rex-rounded-text
        v-if="pickUpLocationData.code === 'A' && !mainServiceIsTours"
        label="рейс, прибытие"
        store-module="cart"
        getter-name="getServiceField"
        setter-name="updateServiceField"
        :target="`transfers.${transferIndex}.form.flightCode`"
        css-class="cart__search-form--w15"
      />
      <rex-rounded-text
        v-if="pickUpLocationData.code === 'A' && !mainServiceIsTours"
        store-module="cart"
        getter-name="getServiceField"
        setter-name="updateServiceField"
        :target="`transfers.${transferIndex}.form.flightNumber`"
        css-class="cart__search-form--w15 cart__search-form--without-label"
      />
    </div>
    <div
      class="cart__search-form--row"
      :class="{ 'cart__search-form--row-tour': mainServiceIsTours }"
    >
      <rex-rounded-autocomplete
        label="Куда"
        store-module="cart"
        getter-name="getServiceField"
        setter-name="updateServiceField"
        :target="`transfers.${transferIndex}.form.cityTo`"
        :css-class="mainServiceIsTours ? 'cart__search-form--w47-75' : 'cart__search-form--w30'"
        endpoint="transfers"
        :disabled="Boolean(getLocations.cityTo.slug)"
        @onChange="changedTransferPlace($event, 'placeTo')"
      />
      <rex-rounded-single-select
        label=""
        store-module="cart"
        getter-name="getServiceField"
        setter-name="updateServiceField"
        :target="`transfers.${transferIndex}.form.placeTo.current`"
        :css-class="mainServiceIsTours
          ? 'cart__search-form--w47-75 cart__search-form--without-label'
          : 'cart__search-form--w30 cart__search-form--without-label'"
        :hide-if-empty="false"
        :is-grouped="true"
        :data="getTransferForm.placeTo.collection"
        :disabled="Boolean(getLocations.placeTo.slug)"
      />
      <rex-rounded-text
        v-if="pickUpLocationData.code === 'A' && !mainServiceIsTours"
        label="рейс, отправление"
        store-module="cart"
        getter-name="getServiceField"
        setter-name="updateServiceField"
        :target="`transfers.${transferIndex}.form.returnFlightCode`"
        css-class="cart__search-form--w15"
      />
      <rex-rounded-text
        v-if="pickUpLocationData.code === 'A' && !mainServiceIsTours"
        store-module="cart"
        getter-name="getServiceField"
        setter-name="updateServiceField"
        :target="`transfers.${transferIndex}.form.returnFlightNumber`"
        css-class="cart__search-form--w15 cart__search-form--without-label"
      />
    </div>
    <div
      class="cart__search-form--row"
      :class="{ 'cart__transfers--back-with-penalties': resultIsShown }"
    >
      <rex-rounded-date
        :label="mainServiceIsTours ? 'Дата подачи' : 'Дата прилета'"
        store-module="cart"
        getter-name="getServiceField"
        setter-name="updateServiceField"
        :target="`transfers.${transferIndex}.form.checkInDate`"
        css-class="cart__search-form--w12"
        :disabled="resultIsShown"
      />
      <rex-rounded-time
        v-if="!mainServiceIsTours"
        label="Время прилета"
        store-module="cart"
        getter-name="getServiceField"
        setter-name="updateServiceField"
        :target="`transfers.${transferIndex}.form.time`"
        css-class="cart__search-form--w12"
        :disabled="resultIsShown"
      />
      <rex-rounded-date
        v-if="!mainServiceIsTours"
        label="Дата вылета"
        store-module="cart"
        getter-name="getServiceField"
        setter-name="updateServiceField"
        :target="`transfers.${transferIndex}.form.checkOutDate`"
        css-class="cart__search-form--w12"
        :disabled="resultIsShown"
      />
      <rex-rounded-time
        v-if="!mainServiceIsTours"
        label="Время вылета"
        store-module="cart"
        getter-name="getServiceField"
        setter-name="updateServiceField"
        :target="`transfers.${transferIndex}.form.returnTime`"
        css-class="cart__search-form--w12"
        :disabled="resultIsShown"
      />
      <rex-rounded-single-select
        v-if="resultIsShown"
        label="Трансфер"
        store-module="cart"
        getter-name="getTransfersCurrent"
        setter-name="updateTransfersCurrent"
        :target="`transfers.${transferIndex}.transfers.current`"
        css-class="cart__search-form--wauto"
        :data="getTransfersCollection"
        @onChange="select($event.event)"
      />
      <button
        v-if="formIsShown"
        class="rex-btn-main rex-btn-main--h40"
        @click="search"
      >
        Найти
      </button>
      <popup-penalties
        v-if="resultIsShown && getTransfer.current.slug"
        :ids="{
          transferSearchId: getTransfer.searchId,
          transferId: getTransfer.current.transferId,
          vehicleId: getTransfer.current.vehicleId
        }"
        store-module="cart"
        service-name="transfers"
        :target="`transfers.${transferIndex}`"
        api-module-name="transfers"
      />
    </div>
  </div>
</template>
